import React, { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DashboardGrid from 'Screens/Contextualization/Dashboard/components/DashboardGrid';
import { EditModeBar, EditModeButton, AddWidgetButton } from './styled';
import selectDashboardLayout from 'store/Preferences/dashboard/selectors';
import { saveDashboardLayout } from 'store/Preferences/dashboard/actions';
import { DASHBOARD_TYPES } from 'store/Preferences/dashboard/defaultLayouts';
import { selectDashboardEditMode, selectIsLayoutSaving } from 'store/Dashboard/selectors';
import { setDashboardEditMode } from 'store/Dashboard/editModeActions';
import SpinnerComponent from 'Common/Components/SpinnerContainer';
import WorkspaceHeader from '../WorkspaceHeader';

const Layout = () => {
  const dispatch = useDispatch();
  const dashboardType = DASHBOARD_TYPES.GENERAL;
  const widgets = useSelector(state => selectDashboardLayout(state, dashboardType));
  const isEditMode = useSelector(selectDashboardEditMode);
  const isLayoutSaving = useSelector(selectIsLayoutSaving);
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(setDashboardEditMode(false));
    };
  }, [dispatch]);

  const handleLayoutChange = useCallback(
    newRows => {
      dispatch(saveDashboardLayout(dashboardType, newRows));
    },
    [dispatch, dashboardType]
  );

  const handleDone = () => {
    dispatch(setDashboardEditMode(false));
    setShowPicker(false);
  };

  return (
    <>
      <WorkspaceHeader dashboardType={ dashboardType } />
      {isEditMode && (
        <EditModeBar>
          <AddWidgetButton onClick={ () => setShowPicker(v => !v) }>
            + Add Widget
          </AddWidgetButton>
          <EditModeButton $active onClick={ handleDone }>
            Done
          </EditModeButton>
        </EditModeBar>
      )}
      {isLayoutSaving
        ? <SpinnerComponent height="60vh" />
        : (
        <DashboardGrid
          rows={ widgets }
          isEditMode={ isEditMode }
          onLayoutChange={ handleLayoutChange }
          showPicker={ showPicker }
          onClosePicker={ () => setShowPicker(false) }
        />
          )
      }
    </>
  );
};

export default Layout;
